import React, { useState, useEffect } from "react";
import "./discussion-box.css";
import { GrEmoji } from "react-icons/gr";
import { LuSend } from "react-icons/lu";
import ChatMessageItem from "../chat-message-item/ChatMessageItem";
import { useSelector } from "react-redux";
import {
  capitalizeAll,
  isEmpty,
  formatMessageDate,
} from "../../../core/utils/helpers";
import { ReactComponent as MessageImage } from "../../../assets/images/message.svg";
//
import {
  onGetDiscussionsMessages,
  onCreateMessages,
} from "../../../modules/admin/services/user";
import moment from "moment";
import { socketIo } from "../../../core/socket/socket-client";
import useAxiosPrivate from "../../../app/providers/context-provider/useAxiosPrivate";
import EmojiPicker from "emoji-picker-react";

const DiscussionBox = () => {
  const axiosPrivate = useAxiosPrivate();

  const [discussionsMessagesData, setDiscussionsMessagesData] = useState([]);
  const [content, setContent] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);

  const currentConnectedStream = useSelector(
    (state) => state.setInitConf.currentConnectedStream,
  );

  const _inscription_id = currentConnectedStream?.inscription_id;

  const currentConversation = useSelector(
    (state) => state.setInitConf.currentConversation,
  );

  const _participant_id = currentConversation?.participant_id;
  const _participant_name = currentConversation?.participant_name;
  const _conv_type = currentConversation?.type;
  const _connexion_status = currentConversation?.connexion_status;

  useEffect(() => {
    onRefreshDiscussions();
  }, [currentConversation]);

  useEffect(() => {
    socketIo.emit("authenticate", { inscription_id: _inscription_id });

    const onHandleNewMessage = (data) => {
      if (data?.status) onRefreshDiscussions();
    };

    socketIo.on("on_new_message", onHandleNewMessage);

    return () => {
      socketIo.off("on_new_message", onHandleNewMessage);
    };
  }, []);

  const onRefreshDiscussions = () => {
    if (!isEmpty(currentConversation)) {
      const localData = {
        inscription_id: _inscription_id,
        participant_id: _participant_id,
        dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };

      onGetDiscussionsMessages(axiosPrivate, localData).then((response) => {
        const _data = response?.data?.result;
        setDiscussionsMessagesData(_data);
      });
    }
  };

  const onEmojiClick = (emojiData) => {
    setContent((prev) => prev + emojiData.emoji);
  };

  const onSubmit = async () => {
    if (isEmpty(content)) return;

    const _data = {
      mode: _conv_type,
      type: "text",
      content: content.trim(),
      status: "sent",
      inscription_id: _inscription_id,
      participant_id: _participant_id,
    };

    onCreateMessages(axiosPrivate, _data).then((response) => {
      const _data = response?.data;
      if (_data?.status) {
        setContent("");
      }
    });
  };

  const onHandleKeyDown = (event) => {
    if (event.key !== "Enter") return;

    if (event.shiftKey) {
      setContent((prev) => prev + "\n");
      return;
    }

    event.preventDefault();
    onSubmit();
  };

  return (
    <div className="discussion-box">
      {isEmpty(_participant_id) ? (
        <div className="chat-container">
          <MessageImage className="chat-image" />
          <p>Start conversation with a Classmate...!</p>
        </div>
      ) : (
        <React.Fragment>
          <div className="discussion-box-head">
            <div className="dis-box-h-profile" key={_participant_id}>
              <img
                src={process.env.PUBLIC_URL + "/user.png"}
                alt="user profile _image"
              />
              <div className="dis-box-h-p-description">
                <h1>{capitalizeAll(_participant_name)}</h1>
                {/* <p>45 members, 24 online</p> */}
                <p>
                  {_conv_type === "P2P"
                    ? _connexion_status
                      ? "online"
                      : "offline"
                    : "45 members, 24 online"}
                </p>
              </div>
            </div>
            {/* <div className="dis-box-h-options">
              <BsSearch className="icon" />
              <MdCall className="icon" />
              <PiSidebarLight className="icon" />
              <MdMoreVert className="icon" />
            </div> */}
          </div>
          <div className="discussion-box-content">
            <div className="discussion-date-grouped">
              {isEmpty(discussionsMessagesData) ? (
                <p
                  style={{
                    fontStyle: "italic",
                    color: "grey",
                    fontSize: "1rem",
                    textAlign: "center",
                  }}
                >
                  No message available yet!
                </p>
              ) : (
                discussionsMessagesData?.map((row, idx) => {
                  return (
                    <React.Fragment key={idx}>
                      <div className="tick-wrapper" key={idx}>
                        {/* <span className="tick-date">Today</span> */}
                        <span className="tick-date">
                          {formatMessageDate(row?.date)}
                        </span>
                      </div>
                      {row?.messages?.map((message, j) => {
                        return (
                          <ChatMessageItem
                            username={
                              message?.conversation_mode !== "P2P" &&
                              message?.sender_id
                            }
                            msg={message?.content}
                            is_right_side={message?.i_am_sender}
                            time={message?.created_at}
                            status={message?.status}
                            key={j + 1}
                          />
                        );
                      })}
                    </React.Fragment>
                  );
                })
              )}
            </div>
          </div>
          <div className="discussion-box-foot">
            <span className="black" onClick={() => setShowEmoji(!showEmoji)}>
              <GrEmoji className="icon" />
            </span>
            <textarea
              wrap="soft"
              placeholder="Your message"
              value={content}
              onChange={(e) => setContent(e?.target?.value)}
              onKeyDown={onHandleKeyDown}
            ></textarea>
            <span
              className={isEmpty(content) ? "grey" : "black"}
              onClick={onSubmit}
            >
              <LuSend className="icon" />
            </span>
            {/* <span className="black">
              <FaMicrophone className="icon" />
            </span> */}
            {showEmoji && (
              <div style={{ position: "absolute", bottom: "50px" }}>
                <EmojiPicker onEmojiClick={onEmojiClick} />
              </div>
            )}
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default DiscussionBox;
